import {
    ModuleWithProviders,
    NgModule,
} from '@angular/core';
import {
    PageCategory,
    PageScope,
    providePageMeta,
} from '@app/router';
import {
    FeatureFlag,
    FolderType,
} from '@models';

@NgModule()
export class MonitoringMetaModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: MonitoringMetaModule,
            providers: [
                providePageMeta({
                    title: 'Monitoring',
                    translationKey: 'page_monitoring',
                    permission: 'Monitoring.View',
                    routerLink: '/monitoring',
                    icon: 'insert_chart',
                    category: PageCategory.Tenant,
                    featureFlag: FeatureFlag.Monitoring,
                    scope: PageScope.Folder,
                    priority: 0,
                }),
                providePageMeta({
                    title: 'Monitoring',
                    translationKey: 'page_queues',
                    permission: 'Monitoring.View&Queues.View',
                    routerLink: '/monitoring/queues',
                    sidebarSection: 'Monitoring',
                    icon: 'insert_chart',
                    type: 'Sidebar',
                    category: PageCategory.Tenant,
                    featureFlag: FeatureFlag.Monitoring,
                    scope: PageScope.Folder,
                    priority: 2,
                }),
                providePageMeta({
                    title: 'Monitoring',
                    translationKey: 'page_queues_monitoring_sla',
                    permission: 'Monitoring.View&Queues.View',
                    routerLink: '/monitoring/queues-sla',
                    sidebarSection: 'Monitoring',
                    icon: 'insert_chart',
                    type: 'SubMenu',
                    category: PageCategory.Tenant,
                    featureFlag: FeatureFlag.QueueSlaMonitoring,
                    scope: PageScope.Folder,
                    parentRoute: '/monitoring/queues',
                }),
                providePageMeta({
                    title: 'Monitoring',
                    translationKey: 'page_queues',
                    permission: 'Monitoring.View&Queues.View',
                    routerLink: '/monitoring/queues/:entityId',
                    sidebarSection: 'Monitoring',
                    icon: 'insert_chart',
                    category: PageCategory.Tenant,
                    featureFlag: FeatureFlag.Monitoring,
                    scope: PageScope.Folder,
                }),
                providePageMeta({
                    title: 'Monitoring',
                    translationKey: 'page_jobs_monitoring_overview',
                    permission: 'Monitoring.View&Jobs.View',
                    routerLink: '/monitoring/jobs',
                    sidebarSection: 'Monitoring',
                    icon: 'insert_chart',
                    parentRoute: '/jobs',
                    type: 'SubMenu',
                    category: PageCategory.Tenant,
                    featureFlag: FeatureFlag.Monitoring,
                    scope: PageScope.Folder,
                    priority: 2,
                }),
                providePageMeta({
                    title: 'Monitoring',
                    translationKey: 'page_jobs_monitoring_overview',
                    permission: 'Monitoring.View&Jobs.View',
                    routerLink: '/monitoring/jobs/:entityId',
                    sidebarSection: 'Monitoring',
                    icon: 'insert_chart',
                    category: PageCategory.Tenant,
                    featureFlag: FeatureFlag.Monitoring,
                    scope: PageScope.Folder,
                    parentRoute: '/jobs',
                }),
                providePageMeta({
                    title: 'Monitoring',
                    translationKey: 'page_robots_monitoring_overview',
                    permission: 'Monitoring.View&Robots.View',
                    routerLink: '/monitoring/robots',
                    sidebarSection: 'Monitoring',
                    icon: 'insert_chart',
                    type: 'SubMenu',
                    parentRoute: '/user-activity',
                    category: PageCategory.Tenant,
                    featureFlag: FeatureFlag.Monitoring,
                    scope: PageScope.Folder,
                    priority: 1,
                    folderTypeDependency: FolderType.Classic,
                }),
                providePageMeta({
                    title: 'Monitoring',
                    translationKey: 'page_robots_monitoring_overview',
                    permission: 'Monitoring.View&Robots.View',
                    routerLink: '/monitoring/robots/:entityId',
                    sidebarSection: 'Monitoring',
                    icon: 'insert_chart',
                    category: PageCategory.Tenant,
                    featureFlag: FeatureFlag.Monitoring,
                    scope: PageScope.Folder,
                    folderTypeDependency: FolderType.Classic,
                    parentRoute: '/user-activity',
                }),
            ],
        };
    }
}
